<template>
  <div v-if="show">
    <a-form labelWrap="true">
      <!-- 字段标识 -->
      <a-form-item :label="$t('fm.config.widget.model')" v-if="data.type!='grid'">
        <a-input v-model="data.model" />
      </a-form-item>
      <!-- 标题 -->
      <a-form-item :label="$t('fm.config.widget.name')" v-if="data.type!=='grid' && data.type!=='divider'">
        <a-input v-model="data.name" />
      </a-form-item>
      <!-- 宽度 -->
      <a-form-item :label="$t('fm.config.widget.width')" v-if="Object.keys(data.options).indexOf('width')>=0">
        <a-input v-model="data.options.width" />
      </a-form-item>

      <!-- 兰玉磊开始添加 -->
      <!-- 标签宽度 -->
      <a-form-item
        :label="$t('fm.config.widget.labelWidth')"
        v-if="Object.keys(data.options).indexOf('labelWidth')>=0 &&
          data.type!=='grid' &&
          data.type!=='subform' &&
          data.type !== 'divider'"
      >
        <a-checkbox v-model="data.options.labelWidthDisabled">自定义</a-checkbox>
        <a-input-number
          :disabled="!data.options.labelWidthDisabled"
          :min="0"
          :step="10"
          v-model="data.options.labelWidth"
        />
      </a-form-item>
      <a-form-item
        label="显示标签"
        v-if="Object.keys(data.options).indexOf('labelWidthStatus')>=0 &&
          data.type!=='grid' &&
          data.type !== 'divider'"
      >
        <a-switch v-model="data.options.labelWidthStatus" />
      </a-form-item>
      <a-form-item :label="$t('fm.config.widget.tip')" v-if="Object.keys(data.options).indexOf('tip')>=0">
        <a-input v-model="data.options.tip" />
      </a-form-item>
      <!-- 兰玉磊结束添加 -->

      <!-- 高度 -->
      <a-form-item :label="$t('fm.config.widget.height')" v-if="Object.keys(data.options).indexOf('height')>=0">
        <a-input v-model="data.options.height" />
      </a-form-item>
      <!-- 大小 -->
      <a-form-item :label="$t('fm.config.widget.size')" v-if="Object.keys(data.options).indexOf('size')>=0">
        {{ $t('fm.config.widget.width') }}
        <a-input style="width: 90px;" type="number" v-model.number="data.options.size.width" />
        {{ $t('fm.config.widget.height') }}
        <a-input style="width: 90px;" type="number" v-model.number="data.options.size.height" />
      </a-form-item>
      <!-- 占位内容 -->
      <a-form-item
        :label="$t('fm.config.widget.placeholder')"
        v-if="Object.keys(data.options).indexOf('placeholder')>=0 && (data.type!='time' || data.type!='date')"
      >
        <a-input v-model="data.options.placeholder" />
      </a-form-item>
      <!-- 布局方式，块，行 -->
      <a-form-item :label="$t('fm.config.widget.layout')" v-if="Object.keys(data.options).indexOf('inline')>=0">
        <a-radio-group v-model="data.options.inline">
          <a-radio-button :label="false">{{ $t('fm.config.widget.block') }}</a-radio-button>
          <a-radio-button :label="true">{{ $t('fm.config.widget.inline') }}</a-radio-button>
        </a-radio-group>
      </a-form-item>
      <!-- 显示输入框 -->
      <a-form-item :label="$t('fm.config.widget.showInput')" v-if="Object.keys(data.options).indexOf('showInput')>=0">
        <a-switch v-model="data.options.showInput" />
      </a-form-item>
      <!-- 最小值 -->
      <a-form-item :label="$t('fm.config.widget.min')" v-if="Object.keys(data.options).indexOf('min')>=0">
        <a-input-number :max="100" :min="0" :step="1" v-model="data.options.min" />
      </a-form-item>
      <!-- 最大值 -->
      <a-form-item :label="$t('fm.config.widget.max')" v-if="Object.keys(data.options).indexOf('max')>=0">
        <a-input-number :max="100" :min="0" :step="1" v-model="data.options.max" />
      </a-form-item>
      <!-- 步长 -->
      <a-form-item :label="$t('fm.config.widget.step')" v-if="Object.keys(data.options).indexOf('step')>=0">
        <a-input-number :max="100" :min="0" :step="1" v-model="data.options.step" />
      </a-form-item>
      <!-- 是否多选 -->
      <a-form-item :label="$t('fm.config.widget.multiple')" v-if="data.type=='select'">
        <a-switch @change="handleSelectMuliple" v-model="data.options.multiple" />
      </a-form-item>
      <!-- 是否可搜索 -->
      <a-form-item :label="$t('fm.config.widget.filterable')" v-if="data.type=='select'">
        <a-switch v-model="data.options.filterable" />
      </a-form-item>
      <!-- 允许半选 -->
      <a-form-item :label="$t('fm.config.widget.allowHalf')" v-if="Object.keys(data.options).indexOf('allowHalf')>=0">
        <a-switch v-model="data.options.allowHalf" />
      </a-form-item>
      <!-- 支持透明度选择 -->
      <a-form-item :label="$t('fm.config.widget.showAlpha')" v-if="Object.keys(data.options).indexOf('showAlpha')>=0">
        <a-switch v-model="data.options.showAlpha" />
      </a-form-item>
      <!-- 是否显示标签 -->
      <a-form-item :label="$t('fm.config.widget.showLabel')" v-if="Object.keys(data.options).indexOf('showLabel')>=0">
        <a-switch v-model="data.options.showLabel" />
      </a-form-item>
      <!-- 选项 -->
      <a-form-item :label="$t('fm.config.widget.option')" v-if="Object.keys(data.options).indexOf('options')>=0">
        <a-radio-group style="margin-bottom:10px;" v-model="data.options.remote">
          <a-radio-button :value="false" size="small">静态数据</a-radio-button>
          <a-radio-button :value="true" size="small">远程数据</a-radio-button>
        </a-radio-group>
        <template v-if="data.options.remote">
          <div>
            <a-input :addon-before="$t('fm.config.widget.remoteFunc')" style v-model="data.options.remoteFunc">
              <!-- <template slot="prepend">{{ $t('fm.config.widget.remoteFunc') }}</template> -->
            </a-input>
            <a-input :addon-before="$t('fm.config.widget.value')" style v-model="data.options.props.value"></a-input>
            <a-input :addon-before="$t('fm.config.widget.label')" style v-model="data.options.props.label"></a-input>
            <a-input
              :addon-before="$t('fm.config.widget.childrenOption')"
              style
              v-if="data.type === 'cascader'"
              v-model="data.options.props.children"
            ></a-input>
          </div>
        </template>
        <template v-else>
          <template v-if="data.type=='radio' || (data.type=='select'&&!data.options.multiple)">
            <a-radio-group v-model="data.options.defaultValue">
              <draggable
                :list="data.options.options"
                handle=".drag-item"
                tag="ul"
                v-bind="{group:{ name:'options'}, ghostClass: 'ghost',handle: '.drag-item'}"
              >
                <li :key="index" class="flex mb-2" v-for="(item, index) in data.options.options">
                  <a-radio :label="item.value" :value="item.value" style="margin-right: 5px;">
                    <a-input :style="{'width': data.options.showLabel? '90px': '180px' }" v-model="item.value" />
                    <a-input style="width:90px;" v-if="data.options.showLabel" v-model="item.label" />
                    <!-- <input v-model="item.value"/> -->
                  </a-radio>
                  <i class="drag-item" style="font-size: 16px;margin: 0 5px;cursor: move;">
                    <i class="iconfont icon-icon_bars" />
                  </i>
                  <a-button
                    @click="handleOptionsRemove(index)"
                    icon="minus-circle"
                    shape="circle"
                    size="small"
                    type="danger"
                  ></a-button>
                </li>
              </draggable>
            </a-radio-group>
          </template>

          <template v-if="data.type=='checkbox' || (data.type=='select' && data.options.multiple)">
            <a-checkbox-group v-model="data.options.defaultValue">
              <draggable
                :list="data.options.options"
                handle=".drag-item"
                tag="ul"
                v-bind="{group:{ name:'options'}, ghostClass: 'ghost',handle: '.drag-item'}"
              >
                <li :key="index" v-for="(item, index) in data.options.options">
                  <a-checkbox :label="item.value" style="margin-right: 5px;">
                    <a-input :style="{'width': data.options.showLabel? '90px': '180px' }" v-model="item.value" />
                    <a-input style="width:90px;" v-if="data.options.showLabel" v-model="item.label" />
                  </a-checkbox>
                  <i class="drag-item" style="font-size: 16px;margin: 0 5px;cursor: move;">
                    <i class="iconfont icon-icon_bars" />
                  </i>
                  <a-button
                    @click="handleOptionsRemove(index)"
                    circle
                    icon="el-icon-minus"
                    plain
                    style="padding: 4px;margin-left: 5px;"
                    type="danger"
                  />
                </li>
              </draggable>
            </a-checkbox-group>
          </template>

          <template v-if="data.type === 'cascader'">
            <a-tree :data="data.options.options" :expand-on-click-node="false" default-expand-all node-key="id">
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span style="font-size: 12px;">{{ node.label }}</span>
                <span>
                  <a-button @click="() => appendCascaderDialog(data)" type="text">
                    <i class="el-icon-circle-plus" style="font-size: 15px;" />
                  </a-button>
                  <a-button @click="() => editCascaderData(data)" type="text">
                    <i class="el-icon-edit-outline" style="font-size: 15px;" />
                  </a-button>
                  <a-button @click="() => removeCascaderData(node, data)" type="text">
                    <i class="el-icon-remove" style="font-size: 15px; color: #f56c6c" />
                  </a-button>
                </span>
              </span>
            </a-tree>
          </template>

          <div :style="data.type === 'cascader'?{'margin-left': '5px'}: {'margin-left': '22px'}">
            <a-button
              :style="data.type === 'cascader'?{'font-size': '13px'}:{}"
              @click="data.type === 'cascader'?handleAddCascaderTopDialog():handleAddOption()"
              type="text"
            >{{ $t('fm.actions.addOption') }}</a-button>
          </div>
        </template>
      </a-form-item>
      <!-- 默认值 -->
      <a-form-item
        :label="$t('fm.config.widget.defaultValue')"
        v-if="Object.keys(data.options).indexOf('defaultValue')>=0 && (data.type == 'textarea' || data.type == 'input' || data.type=='rate' || data.type=='color' || data.type=='switch')"
      >
        <a-input :rows="5" type="textarea" v-if="data.type=='textarea'" v-model="data.options.defaultValue" />
        <a-input v-if="data.type=='input'" v-model="data.options.defaultValue" />
        <a-rate
          :allow-half="data.options.allowHalf"
          :max="data.options.max"
          style="display:inline-block;vertical-align: middle;"
          v-if="data.type == 'rate'"
          v-model="data.options.defaultValue"
        />
        <a-button
          @click="data.options.defaultValue=0"
          style="display:inline-block;vertical-align: middle;margin-left: 10px;"
          type="text"
          v-if="data.type == 'rate'"
        >{{ $t('fm.actions.clear') }}</a-button>
        <a-color-picker
          :show-alpha="data.options.showAlpha"
          v-if="data.type == 'color'"
          v-model="data.options.defaultValue"
        />
        <a-switch v-if="data.type=='switch'" v-model="data.options.defaultValue" />
      </a-form-item>
      <!-- 显示类型 -->
      <template v-if="data.type == 'time' || data.type == 'date'">
        <a-form-item :label="$t('fm.config.widget.showType')" v-if="data.type == 'date'">
          <a-select v-model="data.options.type">
            <a-select-option value="year" />
            <a-select-option value="month" />
            <a-select-option value="date" />
            <a-select-option value="dates" />
            <!-- <a-select-option value="week"></a-select-option> -->
            <a-select-option value="datetime" />
            <a-select-option value="datetimerange" />
            <a-select-option value="daterange" />
          </a-select>
        </a-form-item>
        <a-form-item :label="$t('fm.config.widget.isRange')" v-if="data.type == 'time'">
          <a-switch v-model="data.options.isRange" />
        </a-form-item>
        <a-form-item :label="$t('fm.config.widget.isTimestamp')" v-if="data.type == 'date'">
          <a-switch v-model="data.options.timestamp" />
        </a-form-item>
        <a-form-item
          :label="$t('fm.config.widget.placeholder')"
          v-if="(!data.options.isRange && data.type == 'time') || (data.type != 'time' && data.options.type != 'datetimerange' && data.options.type != 'daterange')"
        >
          <a-input v-model="data.options.placeholder" />
        </a-form-item>
        <a-form-item
          :label="$t('fm.config.widget.startPlaceholder')"
          v-if="(data.options.isRange) || data.options.type=='datetimerange' || data.options.type=='daterange'"
        >
          <a-input v-model="data.options.startPlaceholder" />
        </a-form-item>
        <a-form-item
          :label="$t('fm.config.widget.endPlaceholder')"
          v-if="data.options.isRange || data.options.type=='datetimerange' || data.options.type=='daterange'"
        >
          <a-input v-model="data.options.endPlaceholder" />
        </a-form-item>
        <a-form-item :label="$t('fm.config.widget.format')">
          <a-input v-model="data.options.format" />
        </a-form-item>
        <a-form-item
          :label="$t('fm.config.widget.defaultValue')"
          v-if="data.type=='time' && Object.keys(data.options).indexOf('isRange')>=0"
        >
          <a-time-picker
            :arrow-control="data.options.arrowControl"
            :value-format="data.options.format"
            key="1"
            style="width: 100%;"
            v-if="!data.options.isRange"
            v-model="data.options.defaultValue"
          />
          <a-time-picker
            :arrow-control="data.options.arrowControl"
            :value-format="data.options.format"
            is-range
            key="2"
            style="width: 100%;"
            v-if="data.options.isRange"
            v-model="data.options.defaultValue"
          />
        </a-form-item>
      </template>
      <!-- 图片上传 -->
      <template v-if="data.type=='imgupload' || data.type=='file'">
        <a-form-item :label="$t('fm.config.widget.limit')">
          <a-input type="number" v-model.number="data.options.length" />
        </a-form-item>
        <a-form-item :label="$t('fm.config.widget.isQiniu')" v-if="Object.keys(data.options).indexOf('isQiniu')>0">
          <a-switch v-model="data.options.isQiniu" />
        </a-form-item>
        <template v-if="data.options.isQiniu">
          <a-form-item :required="true" label="Domain">
            <a-input v-model="data.options.domain" />
          </a-form-item>
          <a-form-item :label="$t('fm.config.widget.tokenFunc')" :required="true">
            <a-input v-model="data.options.tokenFunc" />
          </a-form-item>
        </template>
        <template v-else>
          <a-form-item :label="$t('fm.config.widget.imageAction')" :required="true">
            <a-input v-model="data.options.action" />
          </a-form-item>
          <a-form-item :label="$t('fm.config.widget.setHeaders')">
            <a-row :key="uploadIndex" v-for="(uploadItem, uploadIndex) in headers">
              <a-col :span="10">
                <a-input :rows="1" placeholder="KEY" type="textarea" v-model="uploadItem.key" />
              </a-col>
              <a-col :span="10" style="float: left; margin-left: 10px">
                <a-input :rows="1" placeholder="VALUE" type="textarea" v-model="uploadItem.value" />
              </a-col>
              <a-col :span="2">
                <a-button
                  @click="handleDelHeader(uploadIndex)"
                  circle
                  icon="el-icon-delete"
                  plain
                  style="padding: 4px; margin-left: 5px;"
                  type="danger"
                />
              </a-col>
            </a-row>
            <a-button @click="handleAddHeader" style="font-size: 12px; color: #1890ff" type="text">添加</a-button>
          </a-form-item>
        </template>
      </template>
      <!-- 多行文本 -->
      <template v-if="data.type==='text'">
        <a-form-item label="文字内容">
          <a-input placeholder="请输入文字内容" v-model="data.options.defaultValue" />
        </a-form-item>
        <a-form-item label="文字大小">
          <a-input placeholder="请输入字体大小" v-model="data.options.font_size" />
        </a-form-item>
        <a-form-item label="文字颜色">
          <a-input placeholder="请输入文字颜色" v-model="data.options.font_color" />
        </a-form-item>
        <a-form-item label="设置粗体">
          <a-input placeholder="请输入设置粗体" v-model="data.options.font_weight" />
        </a-form-item>
        <a-form-item label="字体属性">
          <a-input placeholder="请输入字体属性" v-model="data.options.font_family" />
        </a-form-item>
      </template>
      <!-- 分割符 -->
      <template v-if="data.type==='divider'">
        <a-form-item label="文字内容">
          <a-input placeholder="请输入文字内容" v-model="data.options.defaultValue" />
        </a-form-item>
        <a-form-item label="文字位置">
          <a-radio-group v-model="data.options.content_position">
            <a-radio-button label="left">左</a-radio-button>
            <a-radio-button label="center">中间</a-radio-button>
            <a-radio-button label="right">右</a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="分割线方向">
          <a-radio-group v-model="data.options.direction">
            <a-radio-button label="horizontal">横</a-radio-button>
            <a-radio-button label="vertical">竖</a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="文字大小">
          <a-input placeholder="请输入字体大小" v-model="data.options.font_size" />
        </a-form-item>
        <a-form-item label="文字颜色">
          <a-input placeholder="请输入文字颜色" v-model="data.options.font_color" />
        </a-form-item>
        <a-form-item label="设置粗体">
          <a-input placeholder="请输入设置粗体" v-model="data.options.font_weight" />
        </a-form-item>
        <a-form-item label="字体属性">
          <a-input placeholder="请输入字体属性" v-model="data.options.font_family" />
        </a-form-item>
      </template>

      <template v-if="data.type==='blank'">
        <a-form-item :label="$t('fm.config.widget.defaultType')">
          <a-select v-model="data.options.defaultType">
            <a-select-option value="String">{{$t('fm.config.widget.string')}}</a-select-option>
            <a-select-option value="Object">{{$t('fm.config.widget.object')}}</a-select-option>
            <a-select-option value="Array">{{$t('fm.config.widget.array')}}</a-select-option>
          </a-select>
        </a-form-item>
      </template>
      <!-- 珊格 -->
      <template v-if="data.type === 'grid'">
        <a-form-item :label="$t('fm.config.widget.gutter')">
          <a-input type="number" v-model.number="data.options.gutter" />
        </a-form-item>
        <a-form-item :label="$t('fm.config.widget.columnOption')">
          <draggable
            :list="data.columns"
            handle=".drag-item"
            tag="ul"
            v-bind="{group:{ name:'options'}, ghostClass: 'ghost',handle: '.drag-item'}"
          >
            <li :key="index" v-for="(item, index) in data.columns">
              <i class="drag-item" style="font-size: 16px;margin: 0 5px;cursor: move;">
                <i class="iconfont icon-icon_bars" />
              </i>
              <a-input
                :placeholder="$t('fm.config.widget.span')"
                style="width: 100px;"
                type="number"
                v-model.number="item.span"
              />

              <a-button
                @click="handleOptionsRemove(index)"
                circle
                icon="el-icon-minus"
                plain
                style="padding: 4px;margin-left: 5px;"
                type="danger"
              />
            </li>
          </draggable>
          <div style="margin-left: 22px;">
            <a-button @click="handleAddColumn" type="text">{{ $t('fm.actions.addColumn') }}</a-button>
          </div>
        </a-form-item>
        <a-form-item :label="$t('fm.config.widget.justify')">
          <a-select v-model="data.options.justify">
            <a-select-option value="start">{{$t('fm.config.widget.justifyStart')}}</a-select-option>
            <a-select-option value="end">{{$t('fm.config.widget.justifyEnd')}}</a-select-option>
            <a-select-option value="center">{{$t('fm.config.widget.justifyCenter')}}</a-select-option>
            <a-select-option value="space-around">{{$t('fm.config.widget.justifySpaceAround')}}</a-select-option>
            <a-select-option value="space-between">{{$t('fm.config.widget.justifySpaceBetween')}}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :label="$t('fm.config.widget.align')">
          <a-select v-model="data.options.align">
            <a-select-option value="top">{{$t('fm.config.widget.alignTop')}}</a-select-option>
            <a-select-option value="middle">{{$t('fm.config.widget.alignMiddle')}}</a-select-option>
            <a-select-option value="bottom">{{$t('fm.config.widget.alignBottom')}}</a-select-option>
          </a-select>
        </a-form-item>
      </template>
      <!-- 非珊格 -->
      <template v-if="data.type !== 'grid'">
        <a-form-item :label="$t('fm.config.widget.attribute')">
          <a-checkbox
            v-if="Object.keys(data.options).indexOf('readonly')>=0"
            v-model="data.options.readonly"
          >{{ $t('fm.config.widget.readonly') }}</a-checkbox>
          <a-checkbox
            v-if="Object.keys(data.options).indexOf('disabled')>=0"
            v-model="data.options.disabled"
          >{{ $t('fm.config.widget.disabled') }}</a-checkbox>
          <a-checkbox
            v-if="Object.keys(data.options).indexOf('showPassword')>=0"
            v-model="data.options.showPassword"
          >{{ $t('fm.config.widget.showPassword') }}</a-checkbox>
          <a-checkbox
            v-if="Object.keys(data.options).indexOf('editable')>=0"
            v-model="data.options.editable"
          >{{ $t('fm.config.widget.editable') }}</a-checkbox>
          <a-checkbox
            v-if="Object.keys(data.options).indexOf('clearable')>=0"
            v-model="data.options.clearable"
          >{{ $t('fm.config.widget.clearable') }}</a-checkbox>
          <a-checkbox
            v-if="Object.keys(data.options).indexOf('arrowControl')>=0"
            v-model="data.options.arrowControl"
          >{{ $t('fm.config.widget.arrowControl') }}</a-checkbox>
          <a-checkbox
            v-if="Object.keys(data.options).indexOf('isDelete')>=0"
            v-model="data.options.isDelete"
          >{{ $t('fm.config.widget.isDelete') }}</a-checkbox>
          <a-checkbox
            v-if="Object.keys(data.options).indexOf('isEdit')>=0"
            v-model="data.options.isEdit"
          >{{ $t('fm.config.widget.isEdit') }}</a-checkbox>
          <a-checkbox
            v-if="Object.keys(data.options).indexOf('showAllLevels')>=0"
            v-model="data.options.showAllLevels"
          >{{ $t('fm.config.widget.showAllLevels') }}</a-checkbox>
        </a-form-item>
        <a-form-item :label="$t('fm.config.widget.validate')">
          <div v-if="Object.keys(data.options).indexOf('required')>=0">
            <a-checkbox v-model="data.options.required">{{ $t('fm.config.widget.required') }}</a-checkbox>
          </div>
          <a-select v-if="Object.keys(data.options).indexOf('dataType')>=0" v-model="data.options.dataType">
            <a-select-option value="string">{{$t('fm.config.widget.string')}}</a-select-option>
            <a-select-option value="number">{{$t('fm.config.widget.number')}}</a-select-option>
            <a-select-option value="boolean">{{$t('fm.config.widget.boolean')}}</a-select-option>
            <a-select-option value="integer">{{$t('fm.config.widget.integer')}}</a-select-option>
            <a-select-option value="float">{{$t('fm.config.widget.float')}}</a-select-option>
            <a-select-option value="url">{{$t('fm.config.widget.url')}}</a-select-option>
            <a-select-option value="email">{{$t('fm.config.widget.email')}}</a-select-option>
            <a-select-option value="hex">{{$t('fm.config.widget.hex')}}</a-select-option>
          </a-select>

          <div v-if="Object.keys(data.options).indexOf('pattern')>=0">
            <a-input
              :placeholder="$t('fm.config.widget.patternPlaceholder')"
              style=" width: 240px;"
              v-model.lazy="data.options.pattern"
            />
          </div>
        </a-form-item>
      </template>
      <a-form-item label="显示校验" v-if="Object.keys(data.options).indexOf('displayVerifiy')>=0">
        <a-radio-group v-model="data.options.displayVerifiy.type">
          <a-radio label="hide" value="hide">不校验</a-radio>
          <a-radio label="and" value="and">与</a-radio>
          <a-radio label="or" value="or">或</a-radio>
        </a-radio-group>
        <div v-if="data.options.displayVerifiy.type !== 'hide'">
          <template v-for="(item, index) in data.options.displayVerifiy.list">
            <div :key="item.model">
              <a-input :placeholder="$t('fm.config.widget.displayVerifiyPlaceholderModel')" v-model="item.model" />
              <a-input
                :placeholder="$t('fm.config.widget.displayVerifiyPlaceholderValue')"
                style="margin-left:5px"
                v-model="item.value"
              />
              <a-button @click="delDisplayVerifiy(index)" icon="el-icon-remove-outline" type="link" v-if="index > 0">删 除</a-button>
              <hr
                style="background-color: #dcdfe6; border:none; height:1px;"
                v-if="data.options.displayVerifiy.list.length > 1"
              />
            </div>
          </template>
          <a-button @click="addDisplayVerifiy" icon="plus-circle" type="link">新 增</a-button>
        </div>
      </a-form-item>
    </a-form>
    <a-modal :before-close="handleClose" :visible.sync="cascaderDialog" append-to-body title="提示" width="30%">
      <div>
        <a-form :model="addTreeData" label-width="80px" ref="addTreeData">
          <a-form-item :rules="{ required: true, message: 'Label不能为空', trigger: 'blur' }" label="Label" prop="label">
            <a-input style="width: 95%" v-model="addTreeData.label" />
          </a-form-item>
          <a-form-item :rules="{ required: true, message: 'Value不能为空', trigger: 'blur' }" label="Value" prop="value">
            <a-input style="width: 95%" v-model="addTreeData.value" />
          </a-form-item>
        </a-form>
      </div>
      <span class="dialog-footer" slot="footer">
        <a-button @click="cascaderDialog = false">取 消</a-button>
        <a-button @click="operatingStatus==='add'?appendCascaderData():cascaderDialog = false" type="primary">确 定</a-button>
      </span>
    </a-modal>
  </div>
</template>

<script>
  import Draggable from 'vuedraggable'

  export default {
    components: {
      Draggable
    },
    /* eslint-disable */
    props: ['data'],
    name: 'WidgetConfig',
    data () {
      return {
        selectTreeData: {},
        addTreeData: {},
        cascaderDialog: false,
        operatingStatus: 'add',
        validator: {
          type: null,
          required: null,
          pattern: null,
          range: null,
          length: null
        },
        headers: []
      }
    },
    computed: {
      show () {
        if (this.data && Object.keys(this.data).length > 0) {
          return true
        }
        return false
      }
    },
    watch: {
      'data.options.isRange': function (val) {
        if (typeof val !== 'undefined') {
          if (val) {
            this.data.options.defaultValue = null
          } else {
            if (Object.keys(this.data.options).indexOf('defaultValue') >= 0) { this.data.options.defaultValue = '' }
          }
        }
      },
      'data.options.required': function (val) {
        this.validateRequired(val)
      },
      'data.options.dataType': function (val) {
        this.validateDataType(val)
      },
      'data.options.pattern': function (val) {
        this.valiatePattern(val)
      },
      'data.name': function (val) {
        if (this.data.options) {
          this.validateRequired(this.data.options.required)
          this.validateDataType(this.data.options.dataType)
          this.valiatePattern(this.data.options.pattern)
        }
      },
      headers: {
        handler: function (val) {
          if (this.data.options) {
            if (this.headers.length > 0) {
              this.data.options.headers = {}
              for (var headerValue of this.headers) {
                this.data.options.headers[headerValue.key] = headerValue.value
              }
            } else {
              this.data.options.headers = {}
            }
          }
        },
        deep: true
      }
    },
    created () {
      this.handleInitHeaders()
    },
    methods: {
      addDisplayVerifiy () {
        this.data.options.displayVerifiy.list.push({
          model: (new Date()).valueOf(),
          value: '字段值'
        })
      },
      delDisplayVerifiy (index) {
        this.data.options.displayVerifiy.list.splice(index, 1)
      },
      // 级联选择器
      handleAddCascaderTopDialog () {
        this.selectTreeData = "top"
        this.addTreeData = {}
        this.cascaderDialog = true
      },
      handleClose () { },
      appendCascaderDialog (val) {
        this.operatingStatus = 'add'
        this.addTreeData = {}
        this.selectTreeData = val
        this.cascaderDialog = true
      },
      appendCascaderData () {
        this.$refs['addTreeData'].validate((valid) => {
          if (valid) {
            if (this.selectTreeData === 'top') {
              this.data.options.options.push(this.addTreeData)
            } else {
              if (this.selectTreeData.children) {
                this.selectTreeData.children.push(this.addTreeData);
              } else {
                this.$set(this.selectTreeData, 'children', [this.addTreeData]);
              }
            }
            this.cascaderDialog = false
          }
        })
      },
      editCascaderData (val) {
        this.operatingStatus = 'edit'
        this.addTreeData = val
        this.cascaderDialog = true
      },
      removeCascaderData (node, data) {
        const parent = node.parent;
        const children = parent.data.children || parent.data;
        const index = children.findIndex(d => d.id === data.id);
        children.splice(index, 1);
      },

      handleInitHeaders () {
        if (this.data.options) {
          for (var key in this.data.options.headers) {
            this.headers.push({
              key: key,
              value: this.data.options.headers[key]
            })
          }
        }
      },
      handleAddHeader () {
        this.headers.push({
          key: '',
          value: ''
        })
      },
      handleDelHeader (index) {
        this.headers.splice(index, 1)
      },
      handleOptionsRemove (index) {
        if (this.data.type === 'grid') {
          this.data.columns.splice(index, 1)
        } else {
          this.data.options.options.splice(index, 1)
        }
      },
      handleAddOption () {
        if (this.data.options.showLabel) {
          this.data.options.options.push({
            value: this.$t('fm.config.widget.newOption'),
            label: this.$t('fm.config.widget.newOption')
          })
        } else {
          this.data.options.options.push({
            value: this.$t('fm.config.widget.newOption')
          })
        }
      },
      handleAddColumn () {
        this.data.columns.push({
          span: '',
          list: []
        })
      },
      generateRule () {
        this.data.rules = []
        Object.keys(this.validator).forEach(key => {
          if (this.validator[key]) {
            this.data.rules.push(this.validator[key])
          }
        })
      },
      handleSelectMuliple (value) {
        if (value) {
          if (this.data.options.defaultValue) {
            this.data.options.defaultValue = [this.data.options.defaultValue]
          } else {
            this.data.options.defaultValue = []
          }
        } else {
          if (this.data.options.defaultValue.length > 0) {
            this.data.options.defaultValue = this.data.options.defaultValue[0]
          } else {
            this.data.options.defaultValue = ''
          }
        }
      },

      validateRequired (val) {
        if (val) {
          this.validator.required = { required: true, message: `${this.data.name}${this.$t('fm.config.widget.validatorRequired')}` }
        } else {
          this.validator.required = null
        }

        this.$nextTick(() => {
          this.generateRule()
        })
      },

      validateDataType (val) {
        if (!this.show) {
          return false
        }

        if (val) {
          this.validator.type = { type: val, message: this.data.name + this.$t('fm.config.widget.validatorType') }
        } else {
          this.validator.type = null
        }

        this.generateRule()
      },
      valiatePattern (val) {
        if (!this.show) {
          return false
        }

        if (val) {
          this.validator.pattern = { pattern: val, message: this.data.name + this.$t('fm.config.widget.validatorPattern') }
        } else {
          this.validator.pattern = null
        }

        this.generateRule()
      }
    }
  }
</script>

<style scoped>

  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }

</style>
